import React from "react"
import { Button, Modal, Form } from "react-bootstrap"
import "./AtributoModal.css"
import AtributoInput from "./AtributoInput"
import UAI from "../UAI"

const AtributoModal = (props) => {
  const guardarCambios = () => {
    var newvalue = document.getElementById(props.field.key).value
    props.Guardar(newvalue)
  }

  if (!props.cohorte || !props.field) {
    return <></>
  }

  let title = props.readOnly
    ? props.cohorte.nombre + " [" + props.cohorte.id + "]"
    : "Editando " +
      UAI.nombresGrados[props.cohorte.gradoid] +
      " " +
      props.cohorte.nombre +
      " " +
      props.cohorte.id

  return (
    <div className="AtributoModal">
      <Modal show={props.isOpen} onHide={props.Cerrar}>
        <Modal.Header className="h4">{title}</Modal.Header>
        <Modal.Body>
          {!props.readOnly && (
            <Form
              onSubmit={(e) => {
                guardarCambios()
              }}
            >
              <Form.Group>
                <Form.Label>{props.field.Nombre}</Form.Label>
                <AtributoInput atributo={props.field} cohorte={props.cohorte} />
                {props.field.Descripcion !== undefined && (
                  <Form.Text className="text-muted">
                    {props.field.Descripcion}
                  </Form.Text>
                )}
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          {props.Guardar && (
            <Button
              variant="primary"
              onClick={() => {
                guardarCambios()
              }}
            >
              Guardar cambios
            </Button>
          )}
          <Button variant="secondary" onClick={props.Cerrar}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default AtributoModal
